import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  return <Section className="bg-gray-50" data-id="element-11">
      <FadeIn data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] mb-12 text-center" data-id="element-13">
          Lo que intentaste… y por qué te falló
        </h2>

        <div className="grid gap-6" data-id="element-14">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex gap-4" data-id="element-15">
            <XCircle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" data-id="element-16" />
            <div data-id="element-17">
              <h3 className="text-xl font-bold text-[#2D2A26] mb-2" data-id="element-18">
                1) Aromatizantes / difusores
              </h3>
              <p className="text-[#2D2A26]/70" data-id="element-19">
                Tapan, no eliminan. Y cuando se mezclan con el olor real, se
                vuelve un “olor raro” más fuerte y pesado.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex gap-4" data-id="element-20">
            <XCircle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" data-id="element-21" />
            <div data-id="element-22">
              <h3 className="text-xl font-bold text-[#2D2A26] mb-2" data-id="element-23">
                2) Limpiar una sola zona
              </h3>
              <p className="text-[#2D2A26]/70" data-id="element-24">
                Lavas el piso, pero el sofá suelta olor. Lavas el sofá, pero el
                pasillo lo guarda. Cambias la arena, pero la caja retiene olor.
                Es un juego de "golpea al topo".
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex gap-4" data-id="element-25">
            <XCircle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" data-id="element-26" />
            <div data-id="element-27">
              <h3 className="text-xl font-bold text-[#2D2A26] mb-2" data-id="element-28">
                3) Limpieza sin frecuencia
              </h3>
              <p className="text-[#2D2A26]/70" data-id="element-29">
                “Cuando pueda” no compite contra un olor biológico que se
                reinstala todos los días.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex gap-4" data-id="element-30">
            <XCircle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" data-id="element-31" />
            <div data-id="element-32">
              <h3 className="text-xl font-bold text-[#2D2A26] mb-2" data-id="element-33">
                4) El enemigo invisible: paños y trapeadores
              </h3>
              <p className="text-[#2D2A26]/70" data-id="element-34">
                Si tu paño huele, estás repartiendo el problema por todo el
                apartamento en lugar de quitarlo.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}